import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  // mixins: [reactiveProp],
  props: ['chartData', 'loaded'],
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                precision: 0
              },
              gridLines: {
                display: true
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: true
              }
            }
          ]
        },
        legend: {
          display: true
        },
        tooltips: {
          enabled: true,
          mode: 'single',
          callbacks: {
            label: function (tooltipItems) {
              //eslint-disable-next-line
              if(tooltipItems.yLabel == 1) {
                return `${tooltipItems.yLabel} day early`
              } else if (tooltipItems.yLabel > 0) {
                return `${tooltipItems.yLabel} days early`
              } else if (tooltipItems.yLabel == -1) {
                return `${Math.abs(tooltipItems.yLabel)} day late`
              } else if (tooltipItems.yLabel < -1) {
                return `${Math.abs(tooltipItems.yLabel)} days late`
              } else {
                return `Paid on time`
              }
            }
          }
        }
      }
    }
  },
  methods: {
    update() {
      this.$data._chart.update()
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    loaded(isLoaded) {
      if (isLoaded) {
        this.update()
      }
    }
  }
}
